export const WALLET_CONNECT_APP_NAME = 'wallet_connect';
export const WALLET_CONNECT_WALLET_NAME = 'WalletConnect';
export const WALLET_CONNECT_ABOUT_URL = 'https://reown.com/';
